const setLoading = ({ commit }) => {
  commit('setLoading')
}
const cancelLoading = ({ commit }) => {
  commit('cancelLoading')
}

export default {
  setLoading,
  cancelLoading
}
